<template>
  <div>
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-lg-12 d-flex flex-column pb-5" v-if="!pageloader"> 
      <div class="col-12 nojobcard mt-3 backgroundcolor1 mb-4 borderradius10" v-if="jobsList.length<1">
        <div class="row no-gutters d-flex flex-column mb-5 mt-5 text-center" >
          <div class="col p-3 text-center">
            <img src="../../assets/noJobsIcon.svg" class="img-fluid" alt="nojobs">
          </div>
          <span class="fontsize24 black proximanova stylebold mb-3">No Jobs post’s</span>
        </div>
      </div>
      <div v-else>
        <div class="">
            <div class="input-group mb-3" >
                <div class="input-group-prepend " >
                    <span class="input-group-text img-input-group">
                        <img :src="searchimg" class="imgborder" alt="searchimg" /> 
                    </span>
                </div>
                <!-- ENTER SEARCH TEXT -->
                <input
                class="form-control input-border"
                type="text"  
                placeholder="Search Job"  id="searchedInput" autocomplete="off"
                aria-label="Search" v-model="searchText"   
                />
            </div>
            <div class="row no-gutters mt-2 pb-5"  v-if="jobsList.length>0 && !pageloader">
                <div  v-for="(job,index) in filteredList"  :key="index" class="col-6 padding2">
                    <div class="card mb-2 p-4 jobcard text-center">
                        <div class=" p-lg-2 borderradius10 mr-2 mt-2 text-center">
                          <img v-if="job.companyProfileLink" :src="job.companyProfileLink" class="prof-img rounded-circle border loadingBgImg" alt="companylogo">
                          <img v-else src="../../assets/Profile_placehlder.svg" class="prof-img rounded-circle border" alt="companylogo">
                        </div>
                        <span class="proximanova-bold fontsize14 black pointer jobtitle" @click="selectedJob(job)">{{job.jobTitle}}</span>
                        <span class="proximanova fontsize12 black60 mt-2">{{job.companyName}}</span>
                        <span class="proximanova fontsize12 black60 mt-2">{{job.city}}, {{job.country}}</span>
                        <span class="proximanova fontsize10 black60 mt-3 mb-3">{{job.jobStatistics.totalApplicants}} Candidates applied</span>
                        <span class="proximanova-bold fontsize12 black mt-2 mb-2">{{job.creationD | moment("from", "now", true)}} ago</span>
                        <div class="mb-3 mt-2">
                          <!-- <a class="btn button-create btn-color mr-2 btnsmall mouseoverbtn1"  id="search">
                            <span class="proximanova-semibold fontsize16 black80">Save</span>
                          </a> -->
                          <a class="green fontsize12" v-if="job.applied">Applied</a>
                          <a class="btn backgroundcolor3 borderradius20 mouseoverbtn1" v-else @click="ApplyJob(job)">
                            <span class="fontsize16 white proximanova-semibold">Apply</span>
                          </a>
                        </div>
                    </div>
                </div>
            
            </div>
            <div class="col-12 pb-3 mb-4" v-if="instancepageloader">
                  <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
                </div>
        </div>
      </div>
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
    <MeetYourProfileStrengthModal v-if="openMeetYourProfileStrengthModal" @closeMeetYourProfileStrengthModal="closeMeetYourProfileStrengthModal"></MeetYourProfileStrengthModal>
  </div>
</template>
<script>
import httpuserprofile from '@/js/http-userprofile'
import httpbusiness from "@/js/http-business.js"
import APIerrorModal from '../../components/APIerrorpopup.vue'
import MeetYourProfileStrengthModal from '../../components/MeetYourProfileStrength.vue'
import sessionUtils from '@/js/session-util.js'
import $ from 'jquery'
import router from '../../router.js'
export default{
    data(){
        return{
          pageloader : true,
          currentUserProfileId : null,
          searchimg: require('../../assets/Search.svg'),
          //details section
          businessAccountId : null,
          companyprofileId : null,
          searchText : '',
          jobsList : [],
          instanceJobsList : [],
          isScrolled : false,
          instancepageloader : false,
          limit : 10,
          offset : 0,
          displayAPIerrorModal : false,
          openMeetYourProfileStrengthModal : false,
        }
    },
    components: {
      APIerrorModal,
      MeetYourProfileStrengthModal
    },
    computed:{
        filteredList(){
            return this.jobsList.filter(job => {
              let jobtext = this.searchText.toLowerCase().trim()
                return job.jobTitle.toLowerCase().includes(jobtext)
            });
        },

    },
    methods :{
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      closeMeetYourProfileStrengthModal() {
        this.openMeetYourProfileStrengthModal = false;
      },
      selectedJob(job) {
          this.$store.state.selectedJob = job.jobAliasId; 
          this.$session.set("selectedJobAliasId", job.jobAliasId);
          this.$router.push({
              name : 'viewjob', params: { id: this.$store.state.selectedJob}
          })
      },
      //get list of posted jobs by company
      getPostedJobsList(){
        var vm = this;
        httpbusiness.get('/business/getPostedjobListForUser?companyProfileId='+this.companyprofileId+'&employeeId='+this.businessAccountId+'&profileId='+this.currentUserProfileId+'&limit='+this.limit+'&offset='+this.offset)
        .then((response) => {
          this.pageloader = false;
          this.instancepageloader = false;
          this.isScrolled = false;
          console.log(response)
          this.instanceJobsList = response.data;
          if(this.instanceJobsList.length > 0){
            for(var i =0; i < this.instanceJobsList.length; i++){
              this.instanceJobsList[i].moremenu = "closemore"+this.instanceJobsList[i].jobId
              this.instanceJobsList[i].jobStatistics = this.instanceJobsList[i].jobStatistics[0]
              this.jobsList.push(this.instanceJobsList[i])
            }
          }
          if(this.instanceJobsList.length < 1) {
            vm.$toast.success("No More Jobs available")
          }
          // this.jobsList = response.data;
        }).catch((e) => {
          console.log(e.response)
          this.instancepageloader = false;
          this.pageloader = false;
        })
      },
      // this will invoke after user clicks on apply button on each job card
      // after succesfully applying if job has any screening question user should navigate to the record screening questions section
      ApplyJob(jobItem) {
        let canbeApply = commonUtils.checkJobLevelToApply(jobItem.seniority)
        if(canbeApply){
        console.log("selected job item : ", jobItem)
        if(jobItem.screeningQuestions && jobItem.screeningQuestions.length > 0){
          this.$session.set("selectedJobId" , jobItem.jobId)
          this.MoveToRecordScreeningQuestions()
        }else{
        let obj = {
            jobId: jobItem.jobId,
            userProfileId: this.currentUserProfileId,
            jobStatus: "POST",
            creationD: null,
            creationUserI: sessionUtils.getUserEmail(),
            updateD: null,
            updatedUserI:null  
        }
        console.log(obj)
        httpuserprofile.post('/userprofile/ApplyToJob', obj)
        .then(response => {    
            console.log("apply for a job : ", response)
            this.$session.set("selectedJobId", jobItem.jobId);
            if(jobItem.screeningQuestions.length > 0){
                this.MoveToRecordScreeningQuestions()
            }
        }).catch(error=>{   
            console.log(error);  
            this.displayAPIerrorModal = true;
        }) 
        }
        }else{
          this.openMeetYourProfileStrengthModal = true;
        }
        // this has  to be called once get successfully applied for the job
        // this.MoveToRecordScreeningQuestions()
      },
      MoveToRecordScreeningQuestions(){
        router.push({
            name : 'recordScreeningQuestions'
        })
      },
      //this will invoke after scrolling down to get more records
      postedJobsPageScroll () {
        if(!this.isScrolled && this.instanceJobsList.length > 8){              
          if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown) {            
            this.isScrolled = true;    
            this.offset = this.offset+10;
            this.instancepageloader = true
            this.getPostedJobsList()        
          }        
        }
      }
    },
    mounted(){
      $('[data-toggle="tooltip"]').tooltip();
      this.currentUserProfileId = sessionUtils.getUserProfileId();  
      this.businessAccountId = this.$session.get("business_account_id")
      this.companyprofileId = this.$session.get("company_profile_id")
      //fetch data
      this.getPostedJobsList()
    },
    created(){
      window.addEventListener('scroll', this.postedJobsPageScroll);
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.postedJobsPageScroll);
    }
}
</script>
<style scoped>
.input-group-text {
  padding: 0px 0px 0px 0px !important;
}
.jobcard{
  border-radius: 10px !important;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.btn-color{
  border-color: rgba(31, 31, 31,0.1);
}
.input-group-prepend{
  margin-right: 0 !important;
  /* background-color: rgba(161, 166, 179,0.1); */
  /* padding: 1px 0px 1px 10px; */
  border-radius: 10px 0 0 10px;
}
.form-control{
    background-color: rgba(161, 166, 179,0.1);
    border: none;
}
.jobtitle:hover{
  color: #007AFF !important;
}
.pageloader {
    width: 8%;
    margin-top: 5%;
    margin-left: 48%;
  }
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}
.imgborder {
	padding: 11px 15px 10px 20px;
	background-color: rgb(161, 166, 179,0.1);
	border-radius: 10px 0px 0px 10px;
  }
  .imgborder-search {
	padding: 11px 15px 11px 10px;
	background-color: rgba(161, 166, 179,0.1);
	border-radius: 0px 10px 10px 0px;
  }
.prof-img{
  width: 60px;
  height: 60px;
  padding: 2px;
}
.input-border{
  border-radius: 0px 10px 10px 0px !important;
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
  .btnsmall{
        height: 35px;
        padding: .2rem .5rem !important;
    }
}
</style>

